export const SITE_NAME_AR = "رخام وبلاط الرياض";
export const SITE_NAME_EN = "Riyadh Marble & Tiles";
export const SITE_URL = "https://riyadhrukhambalat.com";

/** Google Search Console — HTML tag verification (keep after verified) */
export const GOOGLE_SITE_VERIFICATION = "Iohc2oi_tSUxU2vmstf2lzZPB2oCpNwmdMOj68fSvfU";

export const SITE_PHONE_DISPLAY = "+966 50 838 3937";
export const SITE_PHONE_TEL = "+966508383937";
export const SITE_EMAIL = "info@riyadhrukhambalat.com";
export const SITE_WHATSAPP_NUMBER = "966508383937";

export const WHATSAPP_MESSAGES = {
  en: {
    default:
      "Hello, I need tile and marble installation service in Riyadh. Can you please help me?",
    quote:
      "Hello, I would like a free quote for tile and marble installation in Saudi Arabia. Please contact me.",
  },
  ar: {
    default:
      "مرحبًا، أحتاج خدمة تركيب بلاط ورخام في الرياض. هل يمكنكم مساعدتي؟",
    quote:
      "مرحبًا، أود الحصول على عرض سعر لتركيب بلاط ورخام في السعودية. يرجى التواصل معي.",
  },
};

/** @param {"en"|"ar"} lang @param {"default"|"quote"} messageKey */
export function getWhatsAppUrl(lang = "en", messageKey = "default") {
  const messages = WHATSAPP_MESSAGES[lang] || WHATSAPP_MESSAGES.en;
  const text = messages[messageKey] || messages.default;
  return `https://wa.me/${SITE_WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const SERVICE_REGIONS = ["Riyadh", "Jeddah", "Makkah", "Madinah", "Saudi Arabia"];
export const SERVICE_REGIONS_AR = ["الرياض", "جدة", "مكة", "المدينة المنورة", "السعودية"];
export const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.593!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1bf975f32!2sRiyadh%20Saudi%20Arabia!5e0!3m2!1sen!2ssa!4v1703158537552!5m2!1sen!2ssa";
